import { toast } from '@/utils/toast';
import { useState } from 'react';
import { notifyMeV2 } from '@/services/product';
import { useRouter } from '@/i18n/navigation';
import { useLocale } from 'next-intl';
import useGlobalStore from '@/store/global.store';

const useNotifyMe = () => {
  const locale = useLocale();
  const { push, back } = useRouter();
  const [loading, setLoading] = useState(false);

  const { setNotifyProducts } = useGlobalStore();

  const handleNotifyMe = async (session, entity_id, fromLogin) => {
    setLoading(true);
    const res = await notifyMeV2(entity_id, session?.user?.id, locale);
    if (res?.data?.data?.[0]?.error) {
      toast.error(
        locale === 'en'
          ? 'Error Occured, please try again'
          : 'حدث خطأ, برجاء إعادة المحاولة'
      );
      setLoading(false);
    } else {
      toast.success(
        locale === 'en'
          ? 'Alert subscription has been saved for this product'
          : 'تم حفظ اشتراك التنبيه لهذا المنتج.'
      );

      setNotifyProducts(entity_id, session?.user?.id);
      if (fromLogin) {
        back();
      }
      setLoading(false);
    }
  };
  return {
    handleNotifyMe,
    loading,
    push,
    locale,
  };
};

export default useNotifyMe;
